import { render } from "./InvoiceRenderer.vue?vue&type=template&id=610d2969&scoped=true&ts=true"
import script from "./InvoiceRenderer.vue?vue&type=script&lang=ts"
export * from "./InvoiceRenderer.vue?vue&type=script&lang=ts"

import "./InvoiceRenderer.vue?vue&type=style&index=0&id=610d2969&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610d2969"]])

export default __exports__